import React, { useState } from 'react'
import { Modal, Input, Pagination } from 'antd'
import { useTranslation } from 'react-i18next'
import { FiSearch } from 'react-icons/fi'
import { api } from '../../../../../../../../../services'

const PixelSearchModal = ({ visible, onClose, onImageSelect }) => {
    const { t } = useTranslation()
    const [searchQuery, setSearchQuery] = useState('')
    const [searchResults, setSearchResults] = useState([])
    const [isSearching, setIsSearching] = useState(false)
    const [stockPage, setStockPage] = useState(1)
    const [stockPerPage, setStockPerPage] = useState(18)
    const [stockTotalResults, setStockTotalResults] = useState(0)

    const onSearchStockImages = async (val, page = 1) => {
        const query = val !== undefined ? val : searchQuery
        if (!query.trim()) return

        setIsSearching(true)
        try {
            const tempData = {
                query: query,
                perPage: stockPerPage,
                page: page
            }

            const response = await api.library.getStockImages(tempData)

            // Transform the API response to match our expected format
            const transformedResults = response.data.photos.map((photo, index) => ({
                id: photo.id || index,
                url: photo.src?.medium || photo.src?.large || photo.src?.original,
                title: photo.alt || `${t('v5:stock_image')} ${index + 1}`,
                photographer: photo.photographer,
                photographer_url: photo.photographer_url
            }))

            setSearchResults(transformedResults)
            setStockTotalResults(response.data.total_results)
            setStockPage(response.data.page)
            setStockPerPage(response.data.per_page)
        } catch (err) {
            setSearchResults([])
        } finally {
            setIsSearching(false)
        }
    }

    const handlePageChange = page => {
        onSearchStockImages(searchQuery, page)
        setTimeout(() => {
            const resultsContainer = document.querySelector('.pixel-search-results')
            if (resultsContainer) {
                resultsContainer.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                })
            }
        }, 100)
    }

    const handleImageSelect = image => {
        onImageSelect(image)
        setSearchQuery('')
        setSearchResults([])
        setStockPage(1)
        setStockTotalResults(0)
        onClose()
    }

    return (
        <Modal
            title={t('v5:select_pexels_image_title')}
            visible={visible}
            onCancel={onClose}
            footer={null}
            width={800}
            className="pixel-search-modal"
        >
            <div className="pixel-search-content">
                <div className="pixel-search-input">
                    <Input.Search
                        placeholder={t('v5:search_for_stock_images')}
                        value={searchQuery}
                        onChange={e => setSearchQuery(e.target.value)}
                        onSearch={onSearchStockImages}
                        enterButton={<FiSearch />}
                        loading={isSearching}
                        size="large"
                    />
                </div>

                <div className="pixel-search-results">
                    {searchResults.length > 0 ? (
                        <>
                            <div className="pixel-grid">
                                {searchResults.map(image => (
                                    <div
                                        key={image.id}
                                        className="pixel-item"
                                        onClick={() => handleImageSelect(image)}
                                    >
                                        <img src={image.url} alt={image.title} />
                                        <div className="pixel-item-title">{image.title}</div>
                                    </div>
                                ))}
                            </div>
                            {stockTotalResults > stockPerPage && (
                                <div className="pixel-pagination">
                                    <Pagination
                                        current={stockPage}
                                        total={stockTotalResults}
                                        pageSize={stockPerPage}
                                        onChange={handlePageChange}
                                        showSizeChanger={false}
                                        showQuickJumper
                                        showTotal={(total, range) =>
                                            `${range[0]}-${range[1]} ${t(
                                                'v5:pagination_of'
                                            )} ${total} ${t('v5:pagination_images')}`
                                        }
                                    />
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="pixel-search-empty">
                            <p>{t('v4:enter_a_search_term_to_find_stock_images')}</p>
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    )
}

export default PixelSearchModal
